//TODO: Confirm this is not needed
// var checkFlag = String(function(name, defaultValue) {
//     try {
//         var tmp = (localStorage !== null && localStorage.getItem(name));
//         return (tmp != null) ? JSON.parse(tmp) : defaultValue
//     } catch (e) {
//         return defaultValue
//     }
// })

// function useRuntimeFlag(defaultValue) {
//     return { runtimeFlag: defaultValue }
// }

var env = {
    // Setting NODE_ENV to "production" will put React into production mode
    CHROME_APP_ID: 'gioimegmagjcbgcigbbnkdkpjkdckmbk',
    WEBSTORE: 'https://chrome.google.com/webstore/detail/',

    SECTION_UA_HOSTS: [
        'localhost:8001',
        'berkeley.courseload.com',
        'staging.courseload.com',
    ],
    PROXY: undefined,
    SECTION_VIEW: false,
    OFFLINE: true,
    TARGET: 'engage', // The mlx task will set this to 'mlx'
    DEBUG_DRAG_THRESHOLD: false,
    EDIT_HIGHLIGHTS: true,
    ENGAGE_FOR_IOS: false,
    REDSHELF_READER_URL: 'https://platform.virdocs.com',
};

const getProcessedValue = (value, varName) => {
    // Environment variables always come in as strings, so they may have to be
    // converted
    if (value === 'true') {
        return true;
    } else if (value === 'false') {
        return false;
    } else if (!isNaN(parseInt(value, 10))) {
        return parseInt(value, 10);
    }

    return value;

    // TODO: confirm if we still need this code
    // if (value && value.runtimeFlag != null) {
    //     let returnValue
    //     returnValue =
    //     // '('+checkFlag+'('+JSON.stringify(key)+', '+value+'))'
    //     return checkFlag(JSON.stringify(varName), JSON.stringify(value.runtimeFlag))
    //     returnValue = '('+checkFlag+'('+JSON.stringify(varName)+', '+returnValue+'))'
    //     return returnValue
    // } else {
    //
    // }
};

export default Object.keys(env).reduce((memo, varName) => {
    const lookupString = `REACT_APP_${varName}`;
    var value =
        process.env[lookupString] !== undefined
            ? process.env[lookupString]
            : env[varName];
    const updatedValue = getProcessedValue(value, varName);
    return {
        ...memo,
        [varName]: updatedValue,
    };
}, {});



// WEBPACK FOOTER //
// ./src/env.js